export const UNLOCK_MODAL_TITLE = 'Choose below to continue citing'

export const SPONSORED_CTA_TEXT = 'View a sponsored message'
export const SPONSORED_CTA_TAG_TEXT = 'free'

export const SUBSCRIBE_CTA_TEXT = (price = '$9.95') => `Subscribe for ${price} / month`

export const UCF_UNLOCK_MODAL_ID = '--ucf-unlock-modal'

export const FOOTER_BANNER_TEXT = 'Already have an account?'
export const FOOTER_BANNER_CTA_TEXT = 'Sign in'
